<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap10">TWO</h1>
<h1 class="center">Summer of Devils and Angels</h1>
<p class="noind" style="margin-top:30px;">LAST DAY OF SCHOOL — Barbershop Talk — A Boy and a Ball — I Get Around — Welcome, Lucifer — Nemo’s Mother &amp; a Week with the Jaybird — My Camping Trip — Chile Willow — Summer Winds Up</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 14-chap10.vue?4dc99e7e